// frontend/services/callService.js
import axios from "axios";

// ✅ FIXED: Use correct environment variable name
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://justerps.com";
const API_URL = `${API_BASE_URL}/api`; // ✅ Correct: just adds /api once

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60000,
});

// Request interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const callAPI = {
  // Initiate a new call - uses /offer endpoint
  initiateCall: (data) => api.post("/calls/offer", data),
  // Alias for initiateCall (for compatibility with existing code)
  createCallOffer: (data) => api.post("/calls/offer", data),
  
  answerCall: (callId, data) => api.post(`/calls/answer`, { callId, ...data }),
  rejectCall: (callId) => api.post(`/calls/reject`, { callId }),
  endCall: (callId) => api.post(`/calls/end`, { callId }),
  getCallStatus: (callId) => api.get(`/calls/${callId}`),
  getCallHistory: (conversationId) => api.get(`/calls/history/${conversationId}`),
  sendICECandidate: (data) => api.post("/calls/ice-candidate", data),
};

export default callAPI;
